import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-4981">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-4982">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-4983">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-4984">
            <ArrowLeft className="w-4 h-4" data-id="element-4985" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-4986">NOIZA</div>
          <div className="w-20" data-id="element-4987" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-4988">
        <div className="mb-12" data-id="element-4989">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-4990">
            <FileText className="w-6 h-6 text-white/80" data-id="element-4991" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-4992">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-4993">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-4994">
          <section data-id="element-4995">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-4996">
              <span className="text-[#006847]" data-id="element-4997">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-4998">
              <p data-id="element-4999">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5000">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5001">
                <li data-id="element-5002">Haber leído íntegramente este documento</li>
                <li data-id="element-5003">Comprender su contenido en su totalidad</li>
                <li data-id="element-5004">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5005">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5006">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5007">
              <span className="text-[#006847]" data-id="element-5008">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5009">
              <p data-id="element-5010">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5011">
                <li data-id="element-5012">Software como servicio (SaaS)</li>
                <li data-id="element-5013">Marketplace digital gastronómico</li>
                <li data-id="element-5014">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5015">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5016">
                <li data-id="element-5017">Mostrar su menú digital</li>
                <li data-id="element-5018">Recibir pedidos de clientes</li>
                <li data-id="element-5019">Gestionar su operación interna</li>
                <li data-id="element-5020">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5021">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5022">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5023">
              <span className="text-[#006847]" data-id="element-5024">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5025">
              <p data-id="element-5026">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5027">
                <li data-id="element-5028">No es proveedor de alimentos</li>
                <li data-id="element-5029">No participa en la preparación de productos</li>
                <li data-id="element-5030">No manipula alimentos en ningún momento</li>
                <li data-id="element-5031">No realiza entregas ni logística</li>
                <li data-id="element-5032">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5033">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5034">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5035">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5036">
              <span className="text-[#006847]" data-id="element-5037">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5038">
              <p data-id="element-5039">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5040">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5041">
                <li data-id="element-5042">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5043">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5044">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5045">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5046">
                <li data-id="element-5047">Precios</li>
                <li data-id="element-5048">Menú</li>
                <li data-id="element-5049">Horarios</li>
                <li data-id="element-5050">Métodos de pago</li>
                <li data-id="element-5051">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5052">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5053">
              <span className="text-[#006847]" data-id="element-5054">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5055">
              <div data-id="element-5056">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5057">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5058">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5059">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5060">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5061">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5062">
                  <li data-id="element-5063">Calidad de los alimentos</li>
                  <li data-id="element-5064">Estado, frescura o preparación</li>
                  <li data-id="element-5065">Ingredientes utilizados</li>
                  <li data-id="element-5066">Contaminación cruzada</li>
                  <li data-id="element-5067">Problemas de higiene o salubridad</li>
                  <li data-id="element-5068">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5069">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5070">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5071">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5072">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5073">
                  <li data-id="element-5074">Retrasos en la entrega</li>
                  <li data-id="element-5075">Pérdida de pedidos</li>
                  <li data-id="element-5076">Entregas incompletas</li>
                  <li data-id="element-5077">Errores en dirección</li>
                  <li data-id="element-5078">Conducta de repartidores</li>
                  <li data-id="element-5079">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5080">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5081">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5082">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5083">
                  <li data-id="element-5084">Recepción de pagos</li>
                  <li data-id="element-5085">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5086">Manejo de efectivo</li>
                  <li data-id="element-5087">Confirmación de pagos</li>
                  <li data-id="element-5088">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5089">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5090">
                  <li data-id="element-5091">Pagos no recibidos</li>
                  <li data-id="element-5092">Comprobantes falsos</li>
                  <li data-id="element-5093">Errores en montos</li>
                  <li data-id="element-5094">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5095">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5096">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5097">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5098">
                  <li data-id="element-5099">Reclamos de clientes</li>
                  <li data-id="element-5100">Reembolsos</li>
                  <li data-id="element-5101">Cancelaciones</li>
                  <li data-id="element-5102">Disputas</li>
                  <li data-id="element-5103">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5104">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5105">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5106">
              <span className="text-[#006847]" data-id="element-5107">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5108">
              <p data-id="element-5109">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5110">
                <li data-id="element-5111">Responsable</li>
                <li data-id="element-5112">Legal</li>
                <li data-id="element-5113">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5114">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5115">
                <li data-id="element-5116">Publicar información falsa</li>
                <li data-id="element-5117">Manipular precios de forma engañosa</li>
                <li data-id="element-5118">Simular disponibilidad inexistente</li>
                <li data-id="element-5119">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5120">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5121">
              <span className="text-[#006847]" data-id="element-5122">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5123">
              <p data-id="element-5124">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5125">
                <li data-id="element-5126">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5127">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5128">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5129">
                <li data-id="element-5130">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5131">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5132">
                    <li data-id="element-5133">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5134">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5135">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5136">
              <span className="text-[#006847]" data-id="element-5137">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5138">
              <p data-id="element-5139">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5140">
                <li data-id="element-5141">Menú digital</li>
                <li data-id="element-5142">Gestión de pedidos</li>
                <li data-id="element-5143">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5144">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5145">
                  <p className="font-medium text-white mb-2" data-id="element-5146">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5147">
                    <li data-id="element-5148">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5149">
                  <p className="font-medium text-white mb-2" data-id="element-5150">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5151">
                    <li data-id="element-5152">Propiedad del software</li>
                    <li data-id="element-5153">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5154">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5155">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5156">
              <span className="text-[#006847]" data-id="element-5157">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5158">
              <p data-id="element-5159">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5160">
                <li data-id="element-5161">Disponibilidad continua</li>
                <li data-id="element-5162">Funcionamiento sin interrupciones</li>
                <li data-id="element-5163">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5164">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5165">
                <li data-id="element-5166">Fallas técnicas</li>
                <li data-id="element-5167">Actualizaciones</li>
                <li data-id="element-5168">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5169">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5170">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5171">
              <span className="text-[#006847]" data-id="element-5172">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5173">
              <p data-id="element-5174">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5175">
                <li data-id="element-5176">No está garantizada permanentemente</li>
                <li data-id="element-5177">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5178">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5179">
                <li data-id="element-5180">Destacar o no restaurantes</li>
                <li data-id="element-5181">Modificar posiciones</li>
                <li data-id="element-5182">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5183">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5184">
              <span className="text-[#006847]" data-id="element-5185">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5186">
              <p data-id="element-5187">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5188">
                <li data-id="element-5189">Cumplir con los pagos acordados</li>
                <li data-id="element-5190">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5191">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5192">
                <li data-id="element-5193">Suspender el servicio</li>
                <li data-id="element-5194">Limitar funcionalidades</li>
                <li data-id="element-5195">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5196">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5197">
              <span className="text-[#006847]" data-id="element-5198">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5199">
              <p data-id="element-5200">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5201">
                <li data-id="element-5202">Incumplimiento de términos</li>
                <li data-id="element-5203">Uso indebido</li>
                <li data-id="element-5204">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5205">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5206">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5207">
              <span className="text-[#006847]" data-id="element-5208">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5209">
              <p data-id="element-5210">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5211">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5212">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5213">
              <span className="text-[#006847]" data-id="element-5214">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5215">
              <p data-id="element-5216">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5217">
                <li data-id="element-5218">Pérdidas económicas</li>
                <li data-id="element-5219">Daños indirectos</li>
                <li data-id="element-5220">Lucro cesante</li>
                <li data-id="element-5221">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5222">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5223">
              <span className="text-[#006847]" data-id="element-5224">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5225">
              <p data-id="element-5226">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5227">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5228">
              <span className="text-[#006847]" data-id="element-5229">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5230">
              <p className="font-medium" data-id="element-5231">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5232">
                <li data-id="element-5233">Ha leído este documento completo</li>
                <li data-id="element-5234">Comprende su alcance</li>
                <li data-id="element-5235">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}